var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCookingRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 130,
    viewBox: "0 0 280 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.42 91.4497L265.52 83.2197L261.35 92.4497L271.42 91.4497Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32 102.42C179.92 102.42 179.51 102.27 179.2 101.96L176.3 99.0605C175.68 98.4405 175.68 97.4405 176.3 96.8205C176.92 96.2005 177.92 96.2005 178.54 96.8205L181.44 99.7205C182.06 100.34 182.06 101.34 181.44 101.96C181.13 102.27 180.73 102.42 180.32 102.42Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71 40.5206C168.282 40.5206 174.42 34.3824 174.42 26.8106C174.42 19.2388 168.282 13.1006 160.71 13.1006C153.138 13.1006 147 19.2388 147 26.8106C147 34.3824 153.138 40.5206 160.71 40.5206Z",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.42 38.7403C168.992 38.7403 175.13 32.6021 175.13 25.0303C175.13 17.4585 168.992 11.3203 161.42 11.3203C153.848 11.3203 147.71 17.4585 147.71 25.0303C147.71 32.6021 153.848 38.7403 161.42 38.7403Z",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61 28.2906C160.61 31.0806 166.1 30.1006 168.88 26.1006",
    stroke: "#F783AC",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.33 16.3496L155.23 18.6396L158.76 17.5496L157.48 21.0196L159.62 24.0396L155.92 23.8896L153.71 26.8596L152.7 23.2996L149.2 22.1096L152.28 20.0496L152.33 16.3496Z",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59 15.2499L165.22 14.5599L166.71 11.1699L168.49 14.4099L172.17 14.7699L169.65 17.4699L170.44 21.0799L167.09 19.5099L163.9 21.3799L164.35 17.7099L161.59 15.2499Z",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.085 118.448L214.79 120.928L217.27 125.223L221.565 122.743L219.085 118.448Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.731 12.5493L233.383 10.8457L231.679 15.1939L236.027 16.8975L237.731 12.5493Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.75 37.4805L269.7 47.6105L279 43.4505L270.75 37.4805Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.62 11.9302C188.581 11.9302 189.36 11.1512 189.36 10.1902C189.36 9.22922 188.581 8.4502 187.62 8.4502C186.659 8.4502 185.88 9.22922 185.88 10.1902C185.88 11.1512 186.659 11.9302 187.62 11.9302Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57 91.4101C241.39 91.1001 241.33 90.7201 241.43 90.3501C241.63 89.6101 242.39 89.1601 243.14 89.3601L246.64 90.3001C247.38 90.5001 247.83 91.2601 247.63 92.0101C247.43 92.7501 246.67 93.2001 245.92 93.0001L242.42 92.0601C242.04 91.9601 241.75 91.7101 241.57 91.4101Z",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.819 6.73047L190.689 19.2105",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.31 107.96L221.36 96.6104",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.61 2.88965L199.88 17.7496",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3599 85.1699C42.3599 85.1699 37.6699 89.5299 37.6699 97.4699C37.6699 105.41 47.9799 129.12 94.5299 126.56C122.6 125.02 134.27 111.66 139.03 102.21C141.72 96.8699 142.75 90.8099 141.68 84.9299C141.4 83.3699 140.97 81.9099 140.32 80.9199",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.65 83.0508C41.65 83.0508 36.96 87.4108 36.96 95.3508C36.96 103.291 47.2699 127.001 93.8199 124.441C121.89 122.901 133.56 109.541 138.32 100.091C141.01 94.7508 142.04 88.6908 140.97 82.8108C140.69 81.2508 140.26 79.7908 139.61 78.8008",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.901 55.9106C140.901 55.9106 125.361 41.5506 87.9205 44.4906C50.4805 47.4306 41.9404 60.0306 41.9404 60.0306L43.4805 91.8606",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4805 91.8699C43.5705 91.3899 53.7505 119.33 91.6405 116.6C129.531 113.87 137.32 91.8699 137.32 91.8699L140.901 55.9199",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84 56.6405C141.84 56.6405 126.771 42.9605 87.9205 44.4905C49.0705 46.0205 38.9805 68.6405 38.9805 68.6405C41.0205 76.2605 42.5205 84.0305 43.4805 91.8605C44.0905 92.0205 44.7005 91.4805 44.8605 90.8705C45.0205 90.2605 44.8405 89.6205 44.6705 89.0105C43.3305 84.2105 42.2205 79.3505 41.3605 74.4405C41.2005 73.5105 41.1505 72.3305 41.9705 71.8505C42.5005 71.5405 43.1705 71.6905 43.7305 71.9405C47.1105 73.4305 48.2804 77.5405 49.0704 81.1505C49.8804 84.8905 50.6905 88.7605 49.9205 92.5105C49.7805 93.1905 49.6505 94.0605 50.2305 94.4505C51.1605 95.0905 52.0805 93.5905 52.1505 92.4605C52.2605 90.6305 52.1105 88.7905 51.6805 87.0005C51.3505 85.6105 50.8605 84.2505 50.8605 82.8205C50.8605 81.3905 51.4605 79.8505 52.7505 79.2505C54.2305 78.5505 55.9705 79.3205 57.4005 80.1105C59.6505 81.3505 61.8905 82.7105 63.5205 84.7005C66.6305 88.5105 66.8905 93.8505 66.8405 98.7805C66.8405 99.0805 66.8405 99.4005 66.9705 99.6605C67.3405 100.36 68.4805 100.25 68.9705 99.6305C69.4605 99.0105 69.4605 98.1405 69.3705 97.3505C68.9805 94.1505 67.4205 90.7905 68.7705 87.8705C69.0705 87.2305 69.5304 86.6205 70.1904 86.3705C71.7804 85.7605 73.2505 87.4105 74.8005 88.1005C76.7305 88.9605 79.2604 88.4005 80.8204 89.8305C81.2704 90.2505 81.5805 90.7905 81.8705 91.3305C84.3405 96.0005 85.4405 101.38 85.0205 106.65C84.9705 107.3 84.9404 108.06 85.4404 108.47C86.0004 108.93 86.9204 108.6 87.3204 107.98C87.7204 107.36 87.7305 106.59 87.7305 105.86C87.7205 102.95 87.6105 100.05 87.4105 97.1405C87.2505 94.9005 87.1004 92.4405 88.4504 90.6505C90.1204 88.4305 93.3004 88.1905 96.0804 88.1505C96.9504 88.1405 97.8505 88.1305 98.6405 88.5105C100.411 89.3605 100.791 91.6705 100.931 93.6305C101.131 96.3505 101.341 99.0605 101.541 101.78C101.631 102.95 101.981 104.43 103.151 104.6C104.581 104.81 105.22 102.86 105.2 101.42C105.16 98.5905 104.741 95.7705 104.791 92.9505C104.841 90.1205 105.421 87.1905 107.141 84.9505C108.861 82.7105 111.93 81.3405 114.61 82.2405C115.55 82.5505 116.421 83.1505 116.901 84.0105C117.461 84.9905 117.46 86.1905 117.45 87.3205C117.43 89.3005 117.4 91.2805 117.38 93.2605C117.37 94.0205 117.37 94.8105 117.73 95.4805C118.09 96.1505 118.92 96.6305 119.62 96.3205C120.6 95.8805 120.48 94.4705 120.25 93.4205C119.53 90.1705 119.29 86.7105 120.34 83.5505C121.39 80.3905 123.911 77.5805 127.161 76.8605C128.571 76.5505 130.231 76.7105 131.181 77.8005C132.201 78.9605 132.06 80.7005 131.85 82.2305C131.29 86.4605 130.71 90.6905 130.1 94.9205C130 95.6205 129.901 96.3605 130.151 97.0205C130.401 97.6805 131.131 98.2205 131.801 98.0005C132.871 97.6605 132.71 96.1205 132.51 95.0105C131.741 90.7305 133.911 86.5105 134.411 82.1905C134.771 79.0705 134.241 75.8805 134.801 72.7805C135.361 69.6905 137.521 66.4905 140.651 66.2905C140.731 67.9605 140.811 69.6305 140.891 71.3105C140.91 71.7905 140.98 72.3505 141.391 72.6005C142.251 73.1205 142.971 71.7105 142.921 70.7105C142.771 68.0105 141.75 65.2405 142.61 62.6805C142.95 61.6905 143.56 60.7905 143.74 59.7605C143.93 58.7305 143.48 57.4505 142.46 57.2305",
    fill: "#A61E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0703 26.25V53.95L49.2504 55.36C51.2004 58.84 69.3403 67.22 91.4503 67.22C113.56 67.22 131.7 60.25 133.65 56.77L133.83 55.36V26.25H49.0703Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.4503 41.7801C114.856 41.7801 133.83 35.1405 133.83 26.9501C133.83 18.7597 114.856 12.1201 91.4503 12.1201C68.0445 12.1201 49.0703 18.7597 49.0703 26.9501C49.0703 35.1405 68.0445 41.7801 91.4503 41.7801Z",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7201 36.1404C57.5501 36.1404 58.3001 36.7504 59.1001 37.6704C61.3001 40.2204 62.4301 43.5504 62.8601 46.8904C63.2901 50.2304 63.0801 53.6104 62.8701 56.9704C62.8301 57.5604 62.8101 58.1804 63.0901 58.7004C63.3701 59.2204 64.0901 59.5404 64.5701 59.1904C64.9401 58.9304 65.0102 58.4304 65.0402 57.9804C65.4202 52.5304 64.1201 47.0904 64.3901 41.6304C64.4301 40.8404 64.7301 39.8304 65.5101 39.8204C65.8101 39.8104 66.0901 39.9804 66.3401 40.1504C69.8701 42.6404 70.1202 47.6304 70.8002 51.8904C70.9502 52.8204 71.1602 53.8004 71.8102 54.4904C72.4602 55.1704 73.6901 55.3904 74.3201 54.6904C74.9901 53.9404 74.6101 52.7804 74.6401 51.7704C74.7001 50.0104 76.2001 48.5604 77.8701 48.0004C79.5401 47.4304 81.3501 47.5604 83.1101 47.7004C83.9301 47.7604 84.7701 47.8404 85.4901 48.2404C86.0501 48.5604 86.4801 49.0704 86.8301 49.6204C88.6901 52.4904 88.5001 56.1604 89.1101 59.5204C89.3401 60.7604 90.0502 62.2504 91.3002 62.1404C92.5302 62.0304 92.9802 60.4704 93.0402 59.2304C93.1502 56.8104 92.9301 54.3804 93.2101 51.9804C93.4901 49.5804 94.3601 47.1204 96.2301 45.5704C98.1001 44.0204 101.1 43.7204 102.87 45.3804C104.42 46.8304 104.58 49.1904 104.64 51.3204C104.78 56.5404 104.87 61.7604 104.92 66.9804C104.93 67.7404 104.95 68.5504 105.37 69.1804C105.8 69.8104 106.79 70.1104 107.33 69.5804C107.52 69.3904 107.62 69.1404 107.71 68.8804C108.83 65.7204 108.51 62.2504 108.42 58.9004C108.33 55.5404 108.56 51.9604 110.54 49.2504C111.76 53.0704 111.72 57.2904 110.43 61.0904C110.29 61.5004 110.13 61.9504 110.26 62.3704C110.56 63.3604 112.17 63.2204 112.72 62.3504C113.27 61.4804 113.11 60.3604 112.99 59.3304C112.49 55.0704 113.02 50.7704 113.56 46.5104C113.71 45.3004 113.9 44.0104 114.72 43.1104C115.32 42.4404 116.18 42.0904 117.03 41.7804C118.48 41.2604 119.98 40.8504 121.49 40.5504C121.94 40.4604 122.46 40.4004 122.8 40.7004C123.07 40.9404 123.14 41.3304 123.19 41.6904C123.54 44.3404 123.59 47.0304 123.35 49.7004C123.59 50.5904 125.01 50.5904 125.59 49.8704C126.17 49.1504 126.15 48.1304 126.1 47.2104C126.01 45.5604 125.92 43.9004 125.82 42.2504C125.74 40.8504 125.69 39.3304 126.47 38.1704C127.25 37.0104 129.21 36.5604 130.02 37.7004C130.37 38.1904 130.42 38.8204 130.47 39.4104C130.68 42.3804 130.87 45.5004 129.66 48.2104C129.18 49.2804 128.49 50.2704 128.26 51.4204C128.03 52.5704 128.44 53.9804 129.55 54.3704C130.92 51.6104 131.59 48.5704 132.26 45.5704C133.06 41.9604 133.86 38.3404 134.27 34.6604C134.77 30.1104 134.48 25.0204 131.34 21.6904L51.7902 22.8104C48.8802 24.4204 47.7602 28.0904 47.8102 31.4104C47.8602 34.7304 48.7901 37.9904 48.8201 41.3104C48.8301 42.4804 48.9101 43.9604 49.9901 44.4004C50.1601 41.7404 49.9401 39.0504 49.3301 36.4504C48.9301 34.7304 48.3702 32.8504 49.1702 31.2804C50.2402 37.3204 51.3101 43.3704 52.3801 49.4104C52.5001 50.1204 52.6402 50.8404 53.0302 51.4404C53.4202 52.0404 54.1301 52.5004 54.8301 52.3604C56.5401 50.3304 55.6002 47.3004 54.9202 44.7304C54.4402 42.9204 54.1402 41.0604 54.0202 39.1804C53.9802 38.5004 53.9601 37.7904 54.2201 37.1604C54.4801 36.5304 55.0801 35.9904 55.7601 36.0004",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1807 16.2305C88.3007 16.9005 90.2506 18.0805 91.8306 19.6505C92.3706 20.1905 92.8706 20.7805 93.3706 21.3605C94.3806 22.5405 95.4006 23.7505 96.0006 25.1905C96.4106 26.1705 96.6107 27.2305 96.8107 28.2805C96.9207 28.8605 97.0306 29.4405 97.1406 30.0205C97.3506 31.1605 97.5606 32.3905 97.0706 33.4405C97.1106 33.2105 97.1506 32.9705 97.1906 32.7405",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8799 15.5605C90.6999 15.8605 92.1299 17.2405 93.3999 18.5705C94.6799 19.9205 95.9598 21.3305 96.7098 23.0305C97.2098 24.1605 97.4498 25.3805 97.6898 26.5905C97.9698 27.9905 98.2399 29.4205 98.1099 30.8505",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6201 15.3005C91.8401 14.9305 94.0601 16.0005 95.8401 17.3805C97.2701 18.4905 98.5402 19.8405 99.3102 21.4805C100.25 23.4805 100.38 25.7705 100.3 27.9805C100.26 28.9105 100.04 30.0405 99.1602 30.3105",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2803 18.1603C84.4403 17.5903 85.8402 17.9203 87.0002 18.4603C91.2602 20.4503 93.7603 25.0403 94.7703 29.6303C95.2503 31.8203 95.4202 34.2703 94.1902 36.1503C93.9802 36.0703 93.8202 35.9003 93.7402 35.6903",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5998 18.0898C82.5698 18.6198 81.9499 19.7098 81.5599 20.7898C80.5799 23.5198 80.7899 26.8098 82.6499 29.0398C82.8999 29.3298 83.2498 29.6298 83.6198 29.5398",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.431 18.2199C105.771 18.6899 104.901 19.1699 104.211 18.7499C103.601 18.3799 103.541 17.4599 103.911 16.8399C104.271 16.2199 104.921 15.8399 105.551 15.4999C111.011 12.4899 116.861 10.1099 122.991 8.92986C124.421 8.64986 125.951 8.45986 127.271 9.04986C128.601 9.63986 129.531 11.3199 128.841 12.5899",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.52 13.0005C127.36 12.6405 128.28 12.2805 129.16 12.4005C129.31 12.4205 129.47 12.4605 129.61 12.5105C129.71 13.1005 129.11 13.5505 128.58 13.8405C127.35 14.5305 120.291 18.8205 118.931 17.3405C117.611 15.8805 125.45 13.4605 126.52 13.0005Z",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.11 21.6203C118.49 22.4403 119.61 22.5103 120.5 22.3903C123.49 22.0003 126.37 20.8203 128.79 19.0103C129.79 18.2603 130.8 17.2003 130.67 15.9503C130.55 14.8103 129.48 13.9303 129.37 12.7803",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0999 45.0401C44.4699 45.1301 43.8798 44.7701 43.3398 44.4201C41.4498 43.1801 39.4199 41.7401 38.8799 39.5501C40.8899 40.2401 42.7999 41.2301 44.5099 42.4801C43.5499 41.4701 42.7199 40.3401 42.0399 39.1301C41.6899 38.5101 41.4499 37.5901 42.0399 37.2001C42.9299 38.4701 43.8998 39.6901 44.9398 40.8401C44.5098 40.0801 44.0699 39.3201 43.6399 38.5701C43.3199 38.0201 42.9998 37.4401 42.9398 36.8101C42.8498 35.9401 43.2699 35.1001 43.6699 34.3301C43.7799 34.1201 43.8999 33.9001 44.1099 33.8101C44.4499 33.6601 44.8299 33.9001 45.1099 34.1501C47.1199 35.9001 48.3899 38.4701 48.5599 41.1201",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4305 44.5C47.0505 48.35 46.0404 52.43 43.6904 55.55",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4803 53.8102C37.6303 53.9602 36.9603 54.7102 36.7803 55.5502C36.5903 56.3902 36.8502 57.2902 37.3302 58.0002C37.5302 58.2902 37.7802 58.5602 38.0902 58.7402C39.2002 59.3802 40.6403 58.5902 41.3803 57.5402C41.8103 56.9302 42.1103 56.1802 41.9703 55.4502C41.8703 54.9302 41.5403 54.4802 41.1703 54.1002C40.6703 53.5902 40.0003 53.1802 39.2903 53.2402C38.5803 53.3002 37.9203 54.0202 38.1403 54.7002",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2402 54.3C42.0902 52.91 43.5802 51.94 45.1902 51.71",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8401 50.7907C46.6601 50.9207 46.04 52.4807 46.57 53.5407C47.1 54.6007 48.4101 55.0906 49.5901 54.9806C50.0301 54.9406 50.4601 54.8307 50.8301 54.5907C51.5501 54.1107 51.8901 53.1607 51.7501 52.3107C51.6101 51.4607 51.0701 50.7007 50.3901 50.1607C49.8801 49.7607 49.2501 49.4607 48.6001 49.5007C47.9501 49.5407 47.3001 50.0006 47.2001 50.6406",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0301 49.1602C46.8401 50.2202 47.4402 51.3702 48.4202 51.8202",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4804 81.7606C41.1804 80.3006 42.6505 79.3806 44.1205 78.7106C45.5905 78.0406 47.1505 77.5006 48.4005 76.4706C45.8605 77.4106 43.0505 77.6206 40.4005 77.0806C42.9105 75.2906 45.7105 73.9106 48.6605 73.0106C46.0005 72.9906 43.3405 72.2806 41.0205 70.9606C40.8005 70.8306 40.5604 70.6906 40.4604 70.4506C40.1604 69.8006 41.0104 69.2306 41.7004 69.0506C44.1804 68.4106 46.8305 68.4906 49.2705 69.2706C47.7905 68.9006 46.4105 68.1406 45.3005 67.1006C47.7505 69.4006 58.4105 73.3406 55.4105 78.1906C52.7505 82.4906 44.7304 83.1006 40.4804 81.7606Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9701 75.1303C63.0501 75.2203 62.0602 75.4103 61.4302 76.1003C60.5302 77.0903 60.8902 78.8403 62.0002 79.5803C63.1102 80.3203 64.6902 80.1003 65.7302 79.2603C66.6402 78.5303 67.1802 77.2403 66.7402 76.1603C66.4702 75.4903 65.8901 75.0103 65.3201 74.5703C64.9601 74.2903 64.5702 74.0103 64.1202 73.9703C63.6702 73.9303 63.1502 74.2403 63.1402 74.6903",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3506 76.7303C62.9606 76.9703 63.6906 76.9103 64.2506 76.5703",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1607 69.3001C71.2407 69.0001 70.2207 69.5201 69.6407 70.2901C69.0607 71.0601 68.8406 72.0401 68.6206 72.9801C68.4206 73.8701 68.2206 74.8401 68.6006 75.6601C68.7906 76.0801 69.1206 76.43 69.4906 76.7C70.7406 77.62 72.5406 77.7101 73.8706 76.9101C74.5106 76.5301 75.0806 75.8401 74.9606 75.1001",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0508 68.97C72.9108 68.85 73.7907 68.96 74.5907 69.29C75.8007 69.78 76.8607 70.88 76.8907 72.19",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8101 70.5701C97.8101 68.7301 98.92 66.9401 100.57 66.1201C100.66 67.8501 100.27 69.6001 99.45 71.1201C99.79 70.9701 100.06 70.6901 100.37 70.4901C100.68 70.2901 101.1 70.1701 101.42 70.3601C101.64 70.4901 101.76 70.7501 101.82 71.0001C102.14 72.3301 100.93 73.8001 99.5601 73.7201C100.05 74.8201 100.19 76.0801 99.95 77.2601C99.92 77.4301 99.87 77.6101 99.74 77.7301C99.48 77.9901 99.0001 77.8501 98.7801 77.5501C98.5701 77.2501 98.5401 76.8601 98.5301 76.4901C98.9701 77.7301 99.0901 79.0901 98.8801 80.3901C98.4001 80.0801 97.9 79.7601 97.59 79.2801C97.28 78.8001 97.22 78.1101 97.6 77.6901",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42 79.0906C101.03 79.8806 102.02 80.2806 102.99 80.5006C106.47 81.2706 110.14 80.0306 113.11 78.0406C113.55 77.7406 114.03 77.3506 114.02 76.8206C114.01 76.4506 113.77 76.1406 113.54 75.8506C112.41 74.4606 111.28 73.0606 110.16 71.6706C109.78 71.2106 109.41 70.7406 108.97 70.3306C107.1 68.5806 104.15 68.1006 101.83 69.1706C101.35 69.3906 100.85 69.7406 100.79 70.2606",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.96 77.46C103.64 77.46 104.33 77.46 105.01 77.46",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.57 74.2207C105.06 74.3107 105.55 74.4107 106.04 74.5007",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.891 71.4199C106.691 71.6299 107.421 72.1099 107.921 72.7799",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.971 75.9999C109.251 75.9399 109.551 75.9799 109.811 76.1099C109.531 76.0699 109.251 76.0299 108.971 75.9899",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.221 67.34C108.931 66.6 109.811 65.86 110.841 65.9C111.231 65.92 111.611 66.05 111.961 66.23C113.211 66.88 114.071 68.23 114.131 69.64C114.201 71.05 113.471 72.47 112.281 73.23C112.491 73.08 112.711 72.92 112.921 72.77",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.221 73.7899C114.001 72.2299 115.671 71.0799 117.401 71.1899C119.131 71.2999 120.721 72.9099 120.561 74.6399C120.521 75.0799 120.381 75.5099 120.221 75.9299C119.951 76.6499 119.631 77.3799 119.021 77.8499C118.191 78.4799 117.051 78.4599 116.011 78.3999C115.691 78.3799 115.351 78.3599 115.071 78.2099C114.791 78.0599 114.571 77.7299 114.641 77.4199",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17 73.3701C117.7 73.5301 118.24 73.6801 118.77 73.8401",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73 37.9902C133.58 38.0602 133.67 37.7502 133.84 37.7202C137.1 36.9802 140.87 38.1202 142.7 40.9102C143.19 41.6502 143.54 42.5602 143.34 43.4202C143.05 44.7002 141.731 45.4202 140.541 45.9502C139.341 46.4902 138.11 47.0002 136.82 47.2302C135.52 47.4502 134.13 47.3602 132.98 46.7302",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.37 49.6404C137.82 49.6204 139.31 49.5004 140.6 48.8404C141.89 48.1804 142.94 46.8904 142.94 45.4404",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.29 22.7499C131.69 22.1799 132.47 22.0499 133.16 21.9099C135.06 21.5199 136.85 20.6199 138.29 19.3299C139.1 18.5999 139.86 17.6199 139.73 16.5299C137.71 16.9599 135.72 17.5399 133.79 18.2499C135.26 17.3399 136.57 16.1599 137.63 14.7899C137.67 14.5799 137.38 14.4799 137.17 14.4899C135.55 14.5099 133.99 15.1999 132.68 16.1599C131.37 17.1099 130.26 18.3199 129.17 19.5199",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7498 64.1904C51.8198 65.1604 51.3099 66.5304 51.3999 67.8804C51.4899 69.2304 52.1598 70.5204 53.2098 71.3604",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4902 64.1203C52.5702 63.5003 53.5202 63.3603 53.9802 63.7903C54.4402 64.2203 54.5402 64.9003 54.6002 65.5203C54.5202 64.8003 55.2003 64.0903 55.9303 64.1403C56.6603 64.2003 57.2303 65.0003 57.0303 65.7003C57.4603 65.0803 58.3803 64.7803 59.0303 65.1703C59.6803 65.5603 59.7802 66.6703 59.1302 67.0703",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3701 68.07C52.4201 67.83 52.5601 67.61 52.7501 67.46C53.4801 67.92 54.0401 68.66 54.2701 69.49C54.0201 68.85 54.5201 68.04 55.2101 67.96C55.9001 67.89 56.5501 68.58 56.4401 69.26C56.9701 69 57.6801 69.15 58.0101 69.64C58.3401 70.13 58.1802 70.89 57.6602 71.17",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6201 72.7002C55.0501 72.9802 55.5602 73.2702 56.0502 73.1002C56.2302 73.0402 56.3902 72.9102 56.5402 72.7902C56.8702 72.5202 57.2102 72.2602 57.5402 71.9902C57.4302 72.1502 57.3201 72.3102 57.2101 72.4702",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5703 66.6102C61.0703 65.7402 62.8004 65.1302 64.5304 65.2902C66.2604 65.4502 67.9804 66.5002 68.5604 68.1402C68.8204 68.8802 68.8504 69.6802 68.8104 70.4602C68.7504 71.6102 68.5303 72.7702 67.9603 73.7602C67.3903 74.7502 66.4204 75.5702 65.2804 75.7402",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9703 65.8203C63.8703 67.3903 62.8203 69.0003 61.8203 70.6403C64.0003 70.3803 66.1603 71.1203 68.2203 71.8503",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1898 67.29C59.1898 68.63 60.3298 69.88 61.5698 71C60.3298 71.2 59.1599 71.8 58.2799 72.69C58.2099 72.76 58.1299 72.86 58.1699 72.96C58.2099 73.06 58.3998 73.01 58.3498 72.92",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6708 70.71C61.5808 72.01 61.8208 73.33 62.3708 74.52",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4099 70.0008C61.0599 70.2608 61.1598 70.9108 61.5798 71.0508C61.9998 71.1908 62.4698 70.7408 62.3498 70.3208C62.2998 70.1508 62.1899 70.0108 62.0499 69.8908C61.7899 69.6608 61.4198 69.5108 61.1098 69.6508C60.7998 69.7908 60.7299 70.3308 61.0599 70.4508",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1505 67.29C58.5305 67.42 58.0604 67.95 57.8404 68.54C57.6204 69.13 57.6004 69.77 57.6104 70.4C57.6104 71.14 57.6404 71.89 57.8504 72.61C58.3204 74.26 59.7804 75.57 61.4604 75.87",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3098 63.8503C54.5398 63.1203 54.6698 61.7003 55.4998 61.0403C56.3298 60.3803 57.6398 60.4903 58.4298 61.2003C59.2198 61.9103 59.4798 63.1103 59.1798 64.1303C59.0198 64.6803 58.5398 65.2703 57.9798 65.1203",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6505 60.96C53.9705 60.43 53.0705 60.2 52.2205 60.34C51.8205 60.41 51.3905 60.58 51.1805 60.93C51.0505 61.15 51.0205 61.41 51.0205 61.66C51.0605 62.77 51.9905 63.77 53.0905 63.9",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.55 76.5105C74.79 74.6705 75.7899 72.5905 76.9799 70.9905C78.1199 69.4605 79.5099 68.0405 81.2399 67.2405C82.7999 66.5305 84.5399 66.3505 86.2599 66.2905C89.1599 66.1805 92.3499 66.5005 94.4099 68.5405C95.9799 70.1005 96.5999 72.5105 96.1399 74.6805C95.6799 76.8505 94.2099 78.7405 92.3199 79.8905C89.8399 81.4005 86.8299 81.6505 83.9399 81.8705C82.3599 81.9905 80.7199 82.0905 79.2599 81.4805C76.5099 80.3305 75.3199 76.9005 75.7699 73.9505",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3105 81.2C78.9105 82.52 80.2605 83.39 81.6705 83.74C83.0805 84.09 84.5605 84 86.0105 83.87C87.9705 83.69 89.9405 83.43 91.7705 82.72C93.6005 82.01 95.3005 80.8 96.2705 79.1C97.2405 77.39 97.3705 75.15 96.3105 73.5",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3398 83.12C80.1598 85.19 82.2199 86.59 84.3899 87.07C86.5599 87.55 88.8399 87.22 90.9899 86.64C92.8699 86.14 94.7499 85.41 96.1599 84.07C97.5699 82.73 98.4199 80.66 97.8699 78.79",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6807 76.8604C79.7807 77.1004 79.8806 77.3503 79.9806 77.5903",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6104 77.75C83.8004 77.9 84.0304 78.01 84.2604 78.08C84.0504 77.97 83.8304 77.86 83.6104 77.75Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.96 73.0502C81.15 72.7502 81.34 72.4602 81.53 72.1602",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9307 74.6704C85.1307 74.4304 85.3206 74.1804 85.5206 73.9404",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 42.2803C138.41 42.2803 138.69 42.2803 138.98 42.2803C138.7 42.2803 138.42 42.2803 138.13 42.2803Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.26 24.6101C109.31 24.4101 108.27 24.2101 107.39 24.6401C106.17 25.2401 105.78 26.8401 105.97 28.1801C106.17 29.5301 106.791 30.7801 107.051 32.1101C107.231 33.0601 107.281 34.1601 108.051 34.7501C108.391 35.0101 108.82 35.1201 109.25 35.1601C110.44 35.2701 111.68 34.8201 112.47 33.9301C113.26 33.0401 113.54 31.7001 113.11 30.5901",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48 25.2803C108.52 26.1903 109.85 28.1803 111.73 29.3803C112.42 29.8303 113.19 30.1603 113.83 30.6803",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.89 24.8604C111.31 26.2004 110.73 27.5504 110.15 28.8904C109.87 29.5504 109.58 30.2104 109.42 30.9104C109.16 32.0404 109.24 33.2204 108.95 34.3404C109 34.1504 109.05 33.9703 109.1 33.7803",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.801 24.7104C109.551 24.6404 109.451 25.0304 109.501 25.3004C110.001 28.2204 110.601 31.1204 111.291 34.0104",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.07 29.5603C109.36 28.8103 111.65 28.0703 113.95 27.3203",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45 25.8701C104.63 26.5901 103.88 27.3801 103.21 28.2501C102.93 28.6201 102.65 29.0101 102.56 29.4701C102.43 30.1301 102.71 30.8001 103.03 31.4001C103.37 32.0401 103.76 32.6601 104.19 33.2501C104.65 33.8801 105.19 34.4901 105.89 34.8401C106.59 35.1801 107.5 35.2101 108.11 34.7201",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.84 31.7605C122.53 32.3105 122.59 33.3305 122.59 34.2105C122.59 34.6905 122.59 35.1905 122.42 35.6405C122.11 36.4605 121.29 37.0005 120.43 37.1905C119.57 37.3805 118.68 37.2605 117.82 37.1105C114.2 36.4605 112.75 33.6005 115.37 30.7505C115.9 30.1705 117.24 28.8505 118.16 29.0605C119.22 29.3005 118.87 31.2905 120.08 30.3305C119.9 30.7005 119.89 31.0505 119.61 31.4205C120.33 31.3405 121.23 31.2705 121.84 31.7605Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.25 33.1104C127.97 33.1104 128.7 33.0204 129.4 32.8404C129.7 32.7604 130 32.6704 130.23 32.4704C130.61 32.1404 130.73 31.6004 130.73 31.1004C130.73 30.2304 130.4 29.3504 129.76 28.7704C129.16 28.1704 128.19 28.0104 127.41 28.2604C127.91 27.8604 128.19 27.2804 128.1 26.6504C127.15 27.6904 125.36 28.1804 124.7 29.4004C123.62 31.4004 125.29 33.1004 127.25 33.1104Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.98 22.6504C122.27 22.8504 123.44 23.7204 124.01 24.8904C124.58 26.0604 124.551 27.5104 123.921 28.6604",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.08 22.6504C117.99 22.8104 116.96 23.3304 116.19 24.1104C115.79 23.6104 115.08 23.4004 114.47 23.5904C113.86 23.7804 113.41 24.3704 113.37 25.0104",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.931 23.2407C119.941 23.0607 120.23 23.1307 120.34 23.2707C121.01 24.1007 120.711 25.5007 119.771 25.9907C120.251 26.1907 120.59 26.6807 120.61 27.2007C120.63 27.7207 120.32 28.2407 119.86 28.4707C120.37 28.3507 120.94 28.7407 121 29.2607C121.07 29.7807 120.62 30.3007 120.1 30.3207",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.17 25.4199C116.71 25.6699 116.46 26.2599 116.59 26.7599C116.72 27.2699 117.23 27.6499 117.76 27.6399",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.08 24.7705C113.39 25.2605 114.44 26.4005 114.8 27.7505C115.08 28.7605 114.99 29.8505 115.2 30.8805",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.37 28.5505C130.78 27.7205 131.71 26.1205 131.73 24.4805C131.75 22.8405 130.85 21.2205 129.46 20.3605C128.56 19.8005 127.24 19.6305 126.54 20.4305",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.97 23.8102C125.97 23.3102 125.97 22.8002 125.96 22.3002C125.96 22.0902 126 21.8202 126.21 21.7702C126.42 21.7302 126.57 21.9602 126.65 22.1502C126.78 22.4602 126.92 22.7802 127.05 23.0902C127.14 23.3002 127.3 23.5402 127.52 23.5002C127.61 23.4802 127.69 23.4202 127.76 23.3502C128.07 23.0602 128.38 22.7702 128.7 22.4802C128.81 22.9502 128.79 23.4602 128.64 23.9202C129.23 23.9302 129.81 24.0002 130.38 24.1302C130.5 24.1602 130.64 24.2202 130.65 24.3402C130.65 24.4202 130.59 24.4902 130.52 24.5502C129.96 25.0102 129.23 25.2602 128.5 25.2402C129.03 25.4702 129.57 25.8102 129.72 26.3602C129.87 26.9102 129.32 27.6102 128.79 27.3702",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.931 21.1704C99.9505 18.3804 97.7305 15.7704 95.3105 13.3604C96.8605 13.4604 98.3204 14.1404 99.5804 15.0504C100.84 15.9604 101.92 17.0904 102.99 18.2104",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.71 17.2306C102.56 15.8606 101.661 14.6906 100.671 13.7306C99.6805 12.7706 98.5705 11.9206 97.7705 10.7906C99.2505 10.8406 100.621 11.6506 101.651 12.7106C102.691 13.7606 103.441 15.0606 104.181 16.3406C103.341 13.4806 102.501 10.6206 101.661 7.77059C103.681 9.22059 104.64 11.7106 105.49 14.0506C105.42 11.4206 106.21 8.77059 107.71 6.60059C107.96 8.99059 107.97 11.4006 107.73 13.7906C108.47 11.5906 110.091 9.69059 112.161 8.63059C111.511 9.98059 110.79 11.2806 109.99 12.5406",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1904 8.04032C93.7804 7.48032 94.8005 7.58032 95.4305 8.09032C96.0605 8.60032 96.3905 9.41032 96.5605 10.2103C96.6305 10.5703 96.6804 10.9503 96.5704 11.2903C96.4604 11.6403 96.1405 11.9403 95.7705 11.9303",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9404 7.84071C96.0504 6.51071 97.6805 5.57071 98.8905 6.13071C100.101 6.69071 100.42 8.55071 99.4805 9.49071",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.901 10.8102C112.231 10.2002 112.201 9.03018 112.821 8.36018C113.441 7.69018 114.571 7.62018 115.301 8.16018C116.031 8.71018 116.281 9.78018 115.911 10.6102",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.24 7.40073C108.75 6.67073 109.54 5.84073 110.38 6.15073C111.03 6.39073 111.26 7.19073 111.32 7.88073C111.36 8.44073 111.15 9.21073 110.59 9.15073",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.17 7.84049C106.11 6.88049 104.96 6.40049 104 6.32049C103.46 6.28049 102.88 6.30049 102.42 6.57049C101.95 6.85049 101.65 7.45049 101.86 7.95049",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6303 7.69998C80.2503 6.41998 79.8603 5.03998 80.2403 3.75998C80.6203 2.46998 82.0904 1.41998 83.3004 1.98998C84.2304 2.42998 84.5903 3.54998 84.8203 4.55998C85.7003 8.27998 86.3403 12.05 86.7403 15.85C86.7803 15.57 86.8203 15.3 86.8603 15.02",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5605 1.71033C83.7705 1.05033 84.6705 0.840326 85.2905 1.13033C85.9105 1.42033 86.3105 2.05033 86.6105 2.67033C88.0805 5.62033 88.4004 9.00033 88.6904 12.2903C88.7504 12.9603 88.8105 13.6303 88.8705 14.3103",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1201 1.99032C86.4601 1.54032 87.1102 1.40032 87.6602 1.54032C88.2102 1.68032 88.6801 2.04032 89.0801 2.44032C90.3401 3.70032 91.0901 5.38032 91.6401 7.07032C92.4001 9.41032 92.7801 12.0803 91.6101 14.2503",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 9.45022C70.51 8.71022 71.02 8.00022 71.72 7.76022C72.42 7.52022 73.26 7.75022 73.73 8.32022",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8206 11.6501C72.5306 10.5001 73.0506 9.15009 74.1306 8.64009C75.2106 8.13009 76.7006 8.73009 76.9706 9.89009",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.86 7.63052C72.14 6.47052 72.8 4.71052 74.1 4.32052C75.4 3.92052 76.93 5.02052 76.98 6.38052",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3506 8.41995C77.3706 7.50995 78.3906 6.75995 79.2706 7.01995C80.1506 7.27995 80.6006 8.44995 80.1306 9.23995",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2805 12.2902C83.4105 12.1202 83.5404 11.9102 83.4904 11.7002C83.4304 11.4402 83.1104 11.3202 82.8504 11.3802C82.5904 11.4402 82.3904 11.6302 82.2004 11.8102C80.9804 12.9702 79.7505 14.1302 78.5305 15.2902C79.6605 12.7702 80.7805 10.2502 81.9105 7.73022C82.0505 7.43022 82.1205 6.96022 81.8005 6.86022C81.5205 6.77022 81.3005 7.09022 81.1805 7.36022C80.6405 8.59022 80.1005 9.82022 79.5505 11.0502C79.6505 9.69022 79.7404 8.32022 79.8404 6.96022C79.6104 6.86022 79.3805 7.11022 79.2705 7.33022C78.1605 9.46022 78.8804 12.0902 78.2004 14.3902C78.2004 13.2602 77.9805 12.1302 77.5605 11.0802C77.4405 10.7902 77.2404 12.9902 77.3704 13.4702C77.6104 14.3302 77.8905 15.2602 78.8005 15.6502C80.7905 16.5002 82.3305 13.6002 83.2805 12.2902Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.58 21.7505C79.67 18.4905 77.9801 15.4605 75.6701 12.9805C75.1801 13.0505 75.24 13.7705 75.44 14.2205C76.31 16.1305 77.2901 17.9905 78.3801 19.7805C77.2701 17.6505 75.7901 15.7005 74.0401 14.0505C73.8301 13.8505 73.5901 13.6505 73.3001 13.6405C72.8401 13.6205 72.5101 14.1405 72.5401 14.5905C72.5701 15.0505 72.84 15.4505 73.1 15.8305C74.69 18.1005 76.2801 20.3605 77.8801 22.6305C76.0001 18.9505 71.85 16.5605 67.73 16.7605C67.49 16.7705 67.22 16.8105 67.09 17.0105C66.87 17.3405 67.2301 17.7505 67.5601 17.9805C69.2401 19.1605 71.0001 20.2505 72.8101 21.2205C70.8801 20.7305 68.9501 20.2405 67.0301 19.7405C66.7501 19.6705 66.4501 19.6005 66.1701 19.6705C65.8901 19.7405 65.6301 20.0105 65.6701 20.2905C65.7001 20.5205 65.9 20.6805 66.09 20.8105C69.61 23.3005 74.18 23.5805 78.49 23.7705",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8104 9.41992C59.3804 10.3199 59.2804 11.3799 59.5404 12.3499C59.0704 12.6699 58.5904 12.9999 58.2404 13.4499C57.8904 13.8999 57.6803 14.4999 57.8303 15.0499C58.0203 15.7699 58.7304 16.1999 59.3904 16.5399C61.2404 17.4999 63.1704 18.3099 65.1504 18.9599",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8398 9.15034C60.1198 8.58034 60.7399 8.25034 61.3599 8.15034C61.9799 8.05034 62.6199 8.16034 63.2399 8.28034C65.5699 8.71034 67.8898 9.21034 70.0798 10.1103C72.2698 11.0103 74.3199 12.3403 75.7899 14.1903",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8506 11.5098C59.3906 10.9998 60.2206 10.9598 60.9606 10.9898C64.2706 11.1298 67.5506 12.0498 70.4506 13.6498C71.5206 14.2398 72.5806 14.9798 73.1306 16.0698",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8701 13.1204C60.7501 12.4804 61.9601 13.0404 62.9501 13.5004C66.2301 15.0204 70.2001 15.4104 72.6901 18.0404",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8506 16.1401C57.3906 15.8101 56.7007 15.9701 56.3007 16.3801C55.9007 16.7901 55.7407 17.3701 55.6807 17.9301C55.4007 17.5301 54.8107 17.3701 54.3707 17.5801C53.9307 17.7901 53.6707 18.3401 53.7907 18.8101C53.6307 18.8301 53.4707 18.8401 53.3007 18.8601C53.0707 19.5501 53.5707 20.3801 54.2807 20.5001",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7502 20.4903C60.2302 20.0403 58.5502 20.1503 57.1102 20.8003C56.3002 21.1703 55.4402 21.7103 54.5802 21.4603C54.4202 23.2103 56.0603 24.9003 57.8103 24.8003",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4301 18.9804C64.1901 18.9104 62.94 19.6104 62.36 20.7004C62.28 20.8504 62.21 21.0204 62.21 21.1904C62.21 21.3704 62.29 21.5304 62.39 21.6804C62.98 22.6304 64.19 23.1504 65.28 22.9204",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4303 27.5705C68.0603 26.8405 67.7502 25.6205 66.9902 25.0205C66.2302 24.4205 65.1902 24.3405 64.2302 24.4505C64.5202 23.9605 64.0102 23.3105 63.4402 23.2505C62.8702 23.1905 62.3402 23.5005 61.8502 23.8105C61.5402 23.0305 60.6203 22.5505 59.8103 22.7505C59.0003 22.9505 58.4002 23.8105 58.5002 24.6405C57.7702 24.4505 56.9402 24.8305 56.6002 25.5005C56.2602 26.1705 56.4402 27.0605 57.0202 27.5505C57.1902 27.6905 57.4103 27.8405 57.4103 28.0605C57.4103 28.3205 57.1202 28.4505 56.9002 28.6005C56.3202 28.9905 56.1502 29.8605 56.5302 30.4405C56.9102 31.0205 57.7802 31.2005 58.3702 30.8205C58.0702 31.4805 58.2802 32.3305 58.8602 32.7605C59.4402 33.1905 60.3102 33.1905 60.8602 32.7305C60.6402 33.0305 60.7202 33.4905 61.0102 33.7405C61.2902 33.9905 61.7203 34.0205 62.0603 33.8705C62.2203 33.8005 62.3803 33.6805 62.5603 33.6705C62.9203 33.6605 63.1702 34.0705 63.5202 34.1105C63.8802 34.1505 64.1702 33.8105 64.3702 33.5005C64.5802 33.1805 64.7902 32.8605 65.0102 32.5405",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5505 24.1904C63.4105 24.2704 62.3605 25.1204 62.0505 26.2204C61.7405 27.3204 62.1904 28.6004 63.1204 29.2604C64.0504 29.9204 65.4004 29.9304 66.3404 29.2704",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8599 29.2402C64.7999 29.6502 64.8899 30.0802 65.1199 30.4202",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1398 33.0508C66.4098 33.1308 65.8697 33.9108 65.9397 34.6408C65.9997 35.3808 66.5597 36.0108 67.2397 36.3008C67.9197 36.5908 68.6898 36.5908 69.4198 36.4608C70.5898 37.3508 72.5498 36.8408 73.1198 35.4808C73.4198 35.8408 74.0098 35.8108 74.3898 35.5408C74.7698 35.2808 74.9997 34.8508 75.2197 34.4308C75.5797 33.7308 75.9598 32.9508 75.8098 32.1808C75.7698 31.9708 75.6897 31.7608 75.6897 31.5508C75.6897 31.3508 75.7398 31.1608 75.7798 30.9708C75.9598 30.0308 75.6698 29.0108 75.0198 28.3108C74.3698 27.6108 73.3698 27.2408 72.4198 27.3608C72.5798 27.0508 72.3997 26.6508 72.1097 26.4508C71.8197 26.2508 71.4597 26.2108 71.1097 26.1808C70.5897 26.1408 70.0498 26.1108 69.5598 26.2908C69.0698 26.4608 68.7198 26.8508 68.5498 27.3408C66.0498 25.6208 65.0998 32.1608 67.1398 33.0508Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4702 30.3207C70.5202 30.1307 69.4901 30.9307 69.4501 31.9007C69.4001 32.8707 70.3502 33.7607 71.3102 33.6707C72.2702 33.5807 73.0202 32.5107 72.7802 31.5707C72.5602 30.7207 71.7402 30.1807 70.9902 29.7207",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8099 29.8406C79.6199 29.0206 77.7898 29.3606 76.9598 30.5406C76.9098 30.4806 77.0098 30.3706 77.0798 30.4206C77.1498 30.4706 77.0798 30.6006 76.9998 30.5706",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3403 36.3501C74.4303 36.3401 74.3103 36.1901 74.2503 36.2501C74.1903 36.3101 74.2303 36.4201 74.2703 36.5001C74.8503 37.6201 75.4903 38.7901 76.5703 39.4301C78.1003 40.3401 80.0403 39.9401 81.7503 39.4501C83.5503 38.9301 85.3303 38.3501 87.0803 37.6901C87.4303 37.5601 87.8304 37.3801 87.9304 37.0201C88.0204 36.7201 87.8703 36.4001 87.7203 36.1201C86.0703 33.1001 83.5603 30.5601 80.5703 28.8701",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3203 32.9502C77.4003 34.2102 79.7404 35.0302 82.1604 35.3302",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8004 25.4405C78.9904 25.2605 78.1403 25.2105 77.3203 25.3105C77.0303 25.3405 76.7404 25.4005 76.5104 25.5705C76.2504 25.7605 76.1104 26.0705 76.0104 26.3805C75.7204 27.3105 75.7603 28.3405 76.1203 29.2405",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7406 26.01C79.6006 25.17 79.2106 24.38 78.6406 23.75C79.4406 24.14 80.0706 24.87 80.3406 25.72",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1205 22.6602C69.1505 22.5202 68.2904 23.5602 68.3604 24.5402C68.4204 25.5202 69.1605 26.3502 70.0205 26.8302",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1899 36.4203C88.9899 36.2903 87.98 37.5303 87.92 38.7403C87.89 39.3303 88.0299 39.9203 88.3199 40.4403C89.0099 41.6803 90.5499 42.3403 91.9499 42.1203C93.5599 41.8703 96.31 39.7003 95 37.9503C94.58 37.3903 93.49 37.2003 92.91 36.8403C91.9 36.2103 91.45 35.4503 90.76 34.5303C90.36 34.8403 90.1899 35.0703 90.3399 35.7203C90.1699 35.6303 90.0899 35.6003 89.9399 35.5603C89.9599 35.6603 90.0899 36.4103 90.1899 36.4203Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6103 33.9102C95.7203 35.9802 96.6704 38.6002 98.5604 39.8302C100.45 41.0602 103.05 40.9402 104.98 39.7702C105.05 39.5802 105 39.3602 104.85 39.2202",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.021 39.4805C99.5206 40.1205 98.8106 40.7605 98.0106 40.6605C97.8106 39.6805 98.1106 38.6505 98.6206 37.7905C99.1406 36.9305 99.8506 36.2205 100.571 35.5205C99.5406 35.5805 98.4906 35.6305 97.4706 35.4105C96.4606 35.1905 95.4706 34.6905 94.8706 33.8505C94.7406 33.6605 94.6206 33.4205 94.6906 33.2005C94.8006 32.8705 95.2406 32.8205 95.5906 32.8605C97.4106 33.0405 99.0806 33.8905 100.701 34.7205C99.5306 34.1205 98.4906 31.5005 98.3206 30.3105C100.451 30.3505 102.281 34.9205 102.521 36.8205C102.691 38.1805 102.851 40.0605 102.251 41.3305C101.461 39.6505 103.091 37.4905 102.011 35.8405C101.481 37.1305 100.891 38.3705 100.021 39.4805Z",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11 39.6906C105.58 38.7306 105.88 37.7006 106.01 36.6506C106.1 35.9206 106.05 35.0706 105.46 34.6406",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3008 30.25C100.781 30.69 102.121 31.57 103.101 32.76",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.671 22.8303C113.261 22.8203 112.981 22.4003 112.841 22.0203C112.551 21.1903 112.611 20.2203 113.091 19.4703C113.561 18.7203 114.461 18.2503 115.341 18.3503C116.431 18.4803 117.231 19.3903 117.911 20.2503C118.161 20.5703 118.421 20.9203 118.511 21.3203C118.601 21.7203 118.471 22.2003 118.111 22.4003",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.53 16.7702C114.76 15.9602 115.12 15.0202 115.94 14.8402C116.75 14.6602 117.47 15.3602 117.98 16.0202C118.44 16.6302 118.87 17.2802 119.09 18.0102C119.31 18.7402 119.28 19.5702 118.88 20.2202",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 17.1799C113.62 16.7099 113.06 16.4099 112.47 16.2599C111.39 15.9899 110.14 16.2299 109.41 17.0699C108.68 17.9099 108.72 19.3799 109.63 20.0199",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.631 20.5305C110.191 19.8105 109.741 19.0705 109.041 18.5905C108.351 18.1105 107.341 17.9805 106.691 18.5005C105.941 19.1005 105.941 20.2405 106.191 21.1705",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.01 23.6707C111.1 22.6007 110.42 21.5207 109.42 21.1307C108.42 20.7407 107.19 21.0707 106.53 21.9107C105.87 22.7507 105.83 24.0307 106.45 24.9107",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.46 22.0304C103.98 21.0004 101.641 21.5704 100.811 23.1804",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2703 25.2805C47.3603 24.2105 41.3102 25.5205 35.4502 26.8305C38.9702 28.2205 42.9102 28.5505 46.6102 27.7605C44.8302 27.8905 43.0503 28.0205 41.2703 28.1405C41.0803 28.1505 40.8902 28.1705 40.7202 28.2505C40.4902 28.3505 40.3303 28.5605 40.1803 28.7505C39.8503 29.1805 39.5103 29.6105 39.1803 30.0405C40.4903 30.7805 42.1302 31.1905 43.4902 30.5505C44.0902 30.2705 44.5802 29.8105 45.1002 29.3905C46.4802 28.2805 48.0703 27.4705 49.6503 26.6705",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9799 25.0801C54.4299 25.5001 53.8799 25.9201 53.2699 26.2401C52.2999 26.7401 51.2099 26.9501 50.2399 27.4401C49.2699 27.9301 48.3799 28.8201 48.3799 29.9101C50.4599 31.0301 52.9798 30.8101 55.3298 30.5601C56.1098 30.4801 56.9698 30.3501 57.4398 29.7301",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7407 25.8705C54.2607 25.7005 53.6906 25.9905 53.4406 26.4405C53.1906 26.8905 53.2007 27.4405 53.3507 27.9305C53.7907 29.3905 55.4907 30.3305 56.9607 29.9505",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6304 51.9802C76.7704 51.8702 76.2504 51.0102 75.8904 50.2202C75.0704 48.4102 74.4504 46.5202 74.0504 44.5702C74.2104 46.6702 74.1604 48.7902 73.8904 50.8802C73.7404 52.0702 73.2703 53.5102 72.0903 53.7002C70.8403 50.5002 70.3404 47.0102 70.6304 43.5902C71.0804 45.7002 71.4803 48.1002 70.2103 49.8502C69.8603 50.3302 69.1803 50.7402 68.7203 50.3602C68.5403 50.2102 68.4604 49.9802 68.3904 49.7602C67.3404 46.2802 68.4504 42.2502 71.1304 39.8002C70.3704 41.8402 68.9603 43.8802 66.8403 44.3502C66.6203 44.4002 66.3804 44.4302 66.1804 44.3302C65.8704 44.1802 65.7703 43.7602 65.8703 43.4302C65.9703 43.1002 66.2103 42.8302 66.4503 42.5902C67.5603 41.4302 69.3704 39.0902 70.9204 38.5802C72.6204 38.0302 73.2104 39.8102 73.9104 41.0802C74.9004 42.8602 76.0403 44.5802 76.8203 46.4602C76.9903 46.8302 78.3304 52.0702 77.6304 51.9802Z",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.37 65.4201C116.87 64.0001 115.57 62.8901 114.09 62.6201C114.89 64.3701 115.87 66.0501 117 67.6201C116.25 67.0201 115.34 66.6001 114.4 66.4201C114.41 66.9301 114.49 67.4801 114.85 67.8501C115.2 68.2201 115.9 68.2901 116.19 67.8701C115.27 68.6501 114.75 69.9001 114.86 71.1001C115.94 70.6501 116.87 69.8101 117.43 68.7801C117.25 70.1301 117.14 71.7201 118.15 72.6501C118.42 71.7301 118.7 70.8101 118.97 69.8901C118.85 70.6601 119.3 71.4801 120.01 71.7901C119.89 70.5501 119.5 69.3401 118.88 68.2601",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.95 62.1104C118.09 62.7204 117.71 63.8404 117.73 64.8904C117.76 65.9404 118.13 66.9604 118.5 67.9404C119.22 69.8204 119.99 71.7104 121.29 73.2504C121.59 73.6004 121.92 73.9404 122.35 74.1104C122.83 74.3104 123.37 74.2803 123.88 74.2003C125.59 73.9303 127.21 73.1004 128.43 71.8604C128.52 71.7704 128.44 71.5803 128.31 71.6003C128.19 71.6203 128.18 71.8503 128.31 71.8503",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.011 59.7201C123.231 59.3501 122.781 58.9501 122.401 58.7601C121.621 58.3701 120.741 58.0001 119.901 58.2201C119.001 58.4501 118.37 59.3701 118.36 60.2901C118.35 61.2201 118.881 62.1001 119.651 62.6201C120.421 63.1401 121.381 63.3201 122.301 63.2401",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.151 62.5405C123.801 61.5805 124.471 60.4405 125.441 60.1305C126.411 59.8205 127.531 60.2805 128.141 61.1005C128.751 61.9105 128.901 63.0105 128.691 64.0105",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66 60.4702C130.12 60.0802 130.73 59.6702 131.27 59.9202C131.56 60.0602 131.73 60.3502 131.88 60.6302C132.3 61.4802 132.55 62.4302 132.6 63.3802",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69 58.7C131.48 57.63 131.37 56.54 131.36 55.45C131.36 54.98 131.46 54.39 131.91 54.25C132.5 55.58 132.94 56.99 133.21 58.42C133.43 57.82 133.68 57.19 134.22 56.84C134.76 56.49 135.64 56.64 135.8 57.26C135.99 58 135.09 58.51 134.71 59.17C135.78 58.73 137 58.69 138.09 59.05C138.28 59.45 138.07 59.95 137.72 60.23C137.37 60.51 136.92 60.61 136.48 60.67C135.59 60.81 134.68 60.84 133.78 60.77C135.05 61.67 135.39 63.63 134.5 64.9C133.38 64.09 132.69 62.73 132.68 61.35",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.12 59.0006C131.39 58.5906 130.61 58.2506 129.8 58.0106C129.62 57.9506 129.42 57.9006 129.24 57.9706C128.83 58.1206 128.85 58.7006 128.94 59.1206",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.181 56.3507C133.301 55.8607 133.771 55.5407 134.231 55.3507C135.831 54.7307 137.821 55.4207 138.701 56.8907C139.021 57.4207 139.191 58.0307 139.371 58.6207C139.521 59.1307 139.671 59.6607 139.591 60.1907C139.531 60.6007 139.321 60.9807 139.111 61.3307C138.061 63.0707 136.591 64.5507 134.861 65.6207",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.6 59.1504C140.37 59.4604 141.34 59.7204 141.94 59.1604C142.6 58.5404 142.28 57.4404 141.84 56.6504C140.38 54.0304 138.14 51.9404 136.21 49.6504",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.75 51.4807C135.47 51.7407 136.21 52.0107 136.74 52.5607C137.27 53.1007 137.53 54.0007 137.11 54.6407C136.6 55.4307 135.45 55.4107 134.52 55.3007C135.21 55.4107 135.97 55.3107 136.54 54.9007C137.11 54.4907 137.46 53.7407 137.28 53.0607C137.11 52.4207 136.54 51.9707 135.98 51.6107C135.3 51.1707 134.33 50.8107 133.74 51.3807",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.311 49.8806C133.901 50.3306 134.62 50.7606 135.34 50.5906C135.99 50.4306 136.46 49.7306 136.35 49.0806C136.25 48.4206 135.581 47.9006 134.921 47.9506",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53 52.5504C131.39 52.3504 131.16 52.2104 130.91 52.1904C130.54 53.6204 131.82 55.2204 133.3 55.1704",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.461 79.7304C109.451 80.8304 107.451 83.6303 105.641 86.2803C107.681 86.3803 109.731 85.3904 110.941 83.7504C110.161 85.0804 109.371 86.4103 108.591 87.7403C108.071 88.6303 107.531 89.6603 107.881 90.6303C108.501 90.8003 109.071 90.2603 109.491 89.7703C110.491 88.6103 111.491 87.4504 112.501 86.2904C112.181 87.0904 111.991 87.9303 111.931 88.7803C111.911 88.9803 111.911 89.2004 112.021 89.3604C112.221 89.6504 112.701 89.6203 112.961 89.3803C113.221 89.1403 113.331 88.7804 113.421 88.4404C114.111 85.7404 114.481 82.9504 114.491 80.1604C114.981 79.7204 115.161 78.9804 114.941 78.3604",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.01 65.6403C123.63 65.2503 122.92 65.3503 122.56 65.7703C122.2 66.1903 122.17 66.8003 122.35 67.3103C122.68 68.2603 123.7 68.9003 124.71 68.8903C125.72 68.8803 126.68 68.3003 127.26 67.4803",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.71 67.1807C127.25 67.5407 126.79 67.9007 126.33 68.2707C126.34 68.7207 126.35 69.2007 126.61 69.5807C127.05 70.2407 128.04 70.2807 128.78 69.9807C129.6 69.6407 130.27 68.9507 130.58 68.1207",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.821 67.3604C130.021 68.0404 129.781 69.3204 130.321 70.2304C130.921 71.2504 132.431 71.5904 133.421 70.9404C134.411 70.2904 134.681 68.7703 133.991 67.8103",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.87 65.0301C121.52 64.3701 122.61 64.6701 123.52 64.7901C124.48 64.9201 125.45 64.7901 126.42 64.7101C128.5 64.5301 130.65 64.5701 132.58 65.3701C133.8 65.8801 134.89 66.6801 135.74 67.6901",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.781 59.0302C144.111 60.4602 145.461 61.9002 147.081 62.9902C148.701 64.0902 150.621 64.8302 152.571 64.7102C151.311 63.3802 150.041 62.0602 148.781 60.7302C149.961 61.8102 151.311 62.9602 152.921 62.9402C153.321 62.9302 153.811 62.7502 153.821 62.3502C153.831 62.0902 153.621 61.8902 153.421 61.7202C152.591 61.0002 151.751 60.2702 150.921 59.5502C152.161 60.2602 153.601 60.6202 155.031 60.5602C153.031 59.5402 151.031 58.5202 149.031 57.5102C149.631 57.6302 150.241 57.6902 150.851 57.6902C147.661 55.2102 143.891 53.4902 139.931 52.7002C140.441 52.7002 140.921 53.0902 141.041 53.5802",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7805 55.7904C45.2405 55.7604 44.6905 55.7404 44.1805 55.9104C43.6705 56.0804 43.2105 56.5004 43.1505 57.0404C43.1005 57.4804 43.3304 57.9004 43.5704 58.2704C43.9504 58.8504 44.4604 59.4304 45.1404 59.5404C45.4804 59.5904 45.8305 59.5204 46.1505 59.3904C47.0705 59.0004 47.7605 58.0704 47.7905 57.0604C47.8205 56.0604 47.1804 55.0604 46.2404 54.7104C45.6204 54.4904 44.8605 54.5704 44.4305 55.0704",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3899 58.7203C40.8799 58.5903 40.33 58.8602 40.04 59.3002C39.76 59.7402 39.7299 60.3103 39.8899 60.8103C40.2799 62.0103 41.8699 62.6503 42.9899 62.0603C44.1099 61.4603 44.46 59.7902 43.68 58.8002",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3101 61.4205C43.2201 61.9305 43.39 62.4705 43.71 62.8805C44.38 63.7405 45.7301 63.9605 46.6401 63.3605C47.5501 62.7605 47.88 61.4405 47.37 60.4805",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9104 57.1104C48.1604 57.6604 47.7303 58.6204 47.8403 59.5504C47.9403 60.4204 48.4603 61.1803 49.0203 61.8503C49.4603 62.3803 49.9603 62.9004 50.6003 63.1504C51.2403 63.4004 52.0603 63.3103 52.5003 62.7803",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2299 54.6103C51.2199 54.4303 51.4198 54.2903 51.5998 54.3003C51.7798 54.3103 51.9398 54.4103 52.0898 54.5203C54.1698 56.0803 55.0999 59.0103 54.2999 61.4803",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.79 57.51C51.89 57.41 51.98 57.31 52.08 57.21",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2207 60.0004C50.2607 60.0704 50.3907 60.0304 50.3907 59.9504C50.3907 59.8704 50.2607 59.8304 50.2207 59.9004",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2201 63.8301C39.8301 63.6801 39.4001 63.6201 38.9801 63.6501C38.5101 64.4701 38.6801 65.6501 39.4601 66.1801C40.2401 66.7101 41.5101 66.3401 41.7601 65.4301C41.5001 65.3301 41.2001 65.5301 41.1301 65.7901C41.0601 66.0501 41.1801 66.3401 41.3801 66.5301C41.6801 66.8201 42.1602 66.9001 42.5402 66.7201C42.9202 66.5501 43.1702 66.1301 43.1602 65.7201C43.5002 65.9301 43.9602 66.0601 44.3102 65.8501C44.6602 65.6401 44.7101 65.0101 44.3301 64.8801",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1102 62.4999C40.6802 62.3399 40.2302 62.8699 40.3202 63.3199C40.4102 63.7699 40.8303 64.0899 41.2703 64.2399C41.8303 64.4399 42.4503 64.4699 43.0203 64.2999",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5005 66.9299C39.2405 67.0299 39.2504 67.4099 39.3504 67.6699C39.6004 68.3299 40.1105 68.9099 40.7905 69.0999C41.4705 69.2899 42.2905 68.9799 42.5505 68.3299C42.6305 68.4999 42.7005 68.6799 42.7805 68.8599C43.8005 68.6899 44.5904 67.6399 44.4804 66.6099C45.0404 66.9099 45.8504 66.5099 45.9404 65.8799",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9404 63.9307C45.6604 63.9507 45.4605 64.2507 45.4605 64.5307C45.4505 64.8107 45.5905 65.0807 45.7205 65.3207C45.9305 65.7207 46.1805 66.1507 46.6005 66.3307C47.1405 66.5707 47.8105 66.3107 48.2005 65.8607C48.6005 65.4207 48.7905 64.8307 48.9705 64.2607C48.5305 64.1307 48.1905 64.7707 48.3905 65.1907C48.5905 65.6007 49.0605 65.8007 49.5005 65.9607C49.0705 66.2707 49.3006 67.0507 49.8106 67.2107C50.3206 67.3707 50.8705 67.0207 51.1405 66.5507C51.4005 66.0907 51.4505 65.5407 51.4805 65.0007",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.34 48.4902C41.87 49.1002 39.68 50.8102 38.5 53.0702",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8605 48.31C43.2505 47.62 43.2605 46.47 43.8805 45.79",
    stroke: "#F06595",
    strokeWidth: 1.4127,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.86 37.1797C172.48 42.0497 163.561 50.7597 163.561 60.6997C163.561 75.9597 184.601 88.3397 210.541 88.3397C236.481 88.3397 257.521 75.9697 257.521 60.6997C257.521 53.7897 253.21 47.4797 246.09 42.6297L239.791 39.5697C236.671 38.0497 233.241 37.2597 229.771 37.2497L185.86 37.1797Z",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92 34.7598C172.54 39.6298 163.62 48.3398 163.62 58.2798C163.62 73.5398 184.66 85.9198 210.6 85.9198C236.55 85.9198 257.58 73.5498 257.58 58.2798C257.58 51.3698 253.27 45.0598 246.15 40.2098L239.85 37.1498C236.73 35.6298 233.3 34.8398 229.83 34.8298L185.92 34.7598Z",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.451 28.7998C190.341 28.7998 182.061 36.3298 177.791 41.6698C174.361 45.9598 173.161 51.5698 174.241 56.9498C176.101 66.1698 183.331 81.8298 211.061 80.8498C242.021 79.7598 247.661 61.8198 248.641 54.0198C249.031 50.9298 248.471 47.7598 246.871 45.0898C246.191 43.9498 244.961 42.5998 243.761 41.6998",
    fill: "#F783AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.72 41.0498L220.31 41.7098C220.31 41.7098 219.1 42.1498 218.7 42.0998C218.3 42.0598 217.49 42.1498 217.29 42.0998C217.09 42.0498 215.75 43.2598 215.75 43.2598L210.61 43.5998C210.61 43.5998 209.47 45.8398 209.08 45.7498C208.69 45.6598 208.11 49.0798 208.11 49.0798C208.11 49.0798 207.53 51.5998 208.11 51.0398C208.69 50.4698 207.68 53.3298 208.19 53.0998C208.7 52.8698 208.06 55.5598 208.06 55.5598L208.78 56.4398L212.19 56.4798L216.28 56.8998C216.28 56.8998 218.91 56.8698 218.61 56.6698C218.31 56.4698 222.11 55.3198 222.11 55.3198L227.53 53.9898L231.22 51.4898L234.76 49.7598L236.53 47.6598L231.55 45.4598L228.55 43.6498L225.84 43.6098L223.72 41.0498Z",
    fill: "#D6336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72 45.3902C232.72 45.3902 239.92 36.4802 230.92 28.8102C224.43 23.2802 215.36 24.0302 215.36 24.0302L212.45 30.6502L214.29 31.5702L217.97 33.4102V37.0902L226.26 39.8502L232.72 45.3902Z",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.72 46.3103C232.72 46.3103 229.04 43.5503 228.11 43.5503C227.18 43.5503 224.421 42.6303 224.421 41.7103C224.421 40.7903 219.811 38.9503 219.811 38.9503H217.021V36.0903L215.35 33.6403L212.44 30.5703",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.78 19.6998L235.45 43.9398L236.41 40.7798L269.13 19.7698C270.38 18.9698 271.92 18.7498 273.34 19.1698L274.78 19.5998",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.4 44.46C236.4 44.46 231.79 47.22 229.95 49.99",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.48 43.54L237.33 45.39",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.711 58.28C199.571 57.67 200.251 56.45 202.161 56.85C202.851 56.99 203.511 57.26 204.201 57.37C206.151 57.67 208.061 56.64 210.041 56.51C212.531 56.35 215.021 57.64 217.451 57.07C218.781 56.76 219.921 55.92 221.191 55.44C223.331 54.62 225.771 54.8 227.851 53.86C229.731 53.01 231.151 51.33 233.031 50.48C234.251 49.93 235.801 49.6 236.321 48.36C236.471 48.01 236.511 47.62 236.631 47.26C236.871 46.56 237.451 45.99 238.141 45.75",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.051 46.8994C238.371 47.4094 239.601 48.1794 240.621 49.1694",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.19 49.5895C235.35 49.5095 235.55 49.5695 235.69 49.6795C235.83 49.7895 235.91 49.9595 236 50.1195C236.31 50.6895 236.671 51.2395 237.161 51.6595C237.651 52.0795 238.3 52.3495 238.94 52.2895",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.721 55.2098C223.971 55.0898 224.281 55.1598 224.521 55.2998C224.761 55.4398 224.941 55.6598 225.131 55.8698C226.231 57.0898 227.671 58.1598 229.311 58.2398",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.681 57.25C213.251 57.32 212.811 57.4 212.411 57.59C212.011 57.78 211.661 58.11 211.541 58.53C211.331 59.25 211.831 60.02 211.641 60.74C211.511 61.24 211.051 61.61 210.551 61.73",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08 57.3594C204.65 58.4194 203.83 60.3694 204.15 61.4694",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.11 65.7803C239.43 67.2603 239.741 68.8503 239.171 70.2503C238.861 71.0203 238.3 71.6703 237.73 72.2803",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.78 32.7002C190.75 32.9802 189.81 33.6102 189.15 34.4502C188.56 35.2002 188.15 36.1402 187.32 36.6102C187.01 36.7802 186.67 36.8802 186.38 37.0802C185.81 37.4702 185.57 38.1902 185.3 38.8302C184.89 39.8302 184.33 40.7702 183.64 41.6102C183.29 42.0402 182.9 42.4602 182.77 42.9902C182.39 44.6202 184.64 46.1202 184.05 47.6902C183.96 47.9202 183.82 48.1302 183.76 48.3702C183.62 49.0102 184.15 49.5902 184.66 50.0002C185.57 50.7502 186.61 51.4802 186.99 52.5902C187.11 52.9502 187.16 53.3502 187.38 53.6602C187.93 54.4602 189.12 54.3002 190.08 54.4802C191.19 54.6902 192.09 55.4502 193.02 56.0802C193.89 56.6602 194.82 57.1502 195.76 57.6302C196.42 57.9702 197.31 58.2802 197.82 57.7402",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.421 54.5996C189.761 55.0096 190.351 56.1296 190.521 56.6296C190.691 57.1196 190.761 57.6396 190.811 58.1596C190.891 59.0296 190.871 59.9596 190.451 60.7196C190.071 61.4096 189.381 61.9296 189.181 62.6996",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.581 54.5996C187.501 54.9596 186.851 55.8296 186.661 56.1396C186.251 56.7796 185.821 57.4196 185.251 57.9296C184.681 58.4396 183.971 58.8096 183.211 58.8496",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.161 51.1299C184.981 52.3399 184.371 53.4799 183.451 54.2899C182.951 54.7299 182.331 55.0799 181.671 55.0699",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.891 46.3096C183.471 47.2696 182.421 49.1696 181.801 50.0196C181.181 50.8596 180.351 51.5796 179.341 51.8696",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.71 58.2803C197.79 58.8603 197.68 59.1403 197.57 59.7203C197.49 60.1203 197.36 60.5403 197.48 60.9403C197.57 61.2403 197.78 61.4803 198 61.7003C198.35 62.0503 198.73 62.3603 199.13 62.6403",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.811 48.6001C194.191 47.3501 194.97 46.2201 196.01 45.4301C196.81 44.8201 197.82 44.4001 198.82 44.5501C199.32 44.6201 199.78 44.8301 200.26 44.9801C201.29 45.3001 202.38 45.3301 203.46 45.3301C205.24 45.3401 207.021 45.3001 208.801 45.2001",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.361 45.2295C208.431 46.0795 207.931 47.3795 208.041 48.6295C208.081 49.1095 208.211 49.5895 208.221 50.0695C208.221 50.5595 208.081 51.0795 207.691 51.3695C208.001 51.4795 208.161 51.8795 208.011 52.1695C208.261 52.5795 208.271 53.1095 208.051 53.5295C207.881 53.8495 207.581 54.1195 207.561 54.4795C207.551 54.6395 207.601 54.7895 207.641 54.9395C207.861 55.6595 208.541 55.7095 208.771 56.4295",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.221 41.05C215.491 40.99 215.691 40.79 215.921 40.63C216.691 40.1 217.671 40.03 218.601 39.94C218.711 39.93 218.821 39.92 218.931 39.88C219.021 39.85 219.101 39.79 219.191 39.75C219.471 39.6 219.801 39.54 220.121 39.57",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223 40.9297C222.55 41.3197 221.881 41.2697 221.291 41.3897C220.411 41.5697 219.6 42.1597 218.7 42.1097C218.39 42.0897 218.091 41.9897 217.781 41.9697C217.221 41.9297 216.651 42.1497 216.271 42.5497",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36 42.6602C188.85 41.6002 189.66 40.7002 190.67 40.1102C191.52 39.6102 192.47 39.3402 193.42 39.0802C194.5 38.7802 195.58 38.4702 196.66 38.1702C197.2 38.0202 197.78 37.8702 198.31 38.0402C198.65 38.1502 198.93 38.3802 199.2 38.6002C199.68 39.0002 200.18 39.4202 200.45 39.9902C200.58 40.2702 200.64 40.5702 200.77 40.8502C200.95 41.2502 201.26 41.5802 201.55 41.9102",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.75 34.9993C196.74 34.2093 198.81 33.6194 200.92 33.2194C201.13 33.1794 201.34 33.1393 201.54 33.1893C201.97 33.2893 202.24 33.7093 202.64 33.9093C203.08 34.1393 203.69 34.0993 203.98 34.4993C204.08 34.6493 204.13 34.8294 204.2 34.9894C204.38 35.3994 204.74 35.6894 205.09 35.9694",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.601 35.2803C194.811 35.8603 195.261 36.3203 195.701 36.7603C196.271 37.3303 196.991 37.6703 197.711 38.0203",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.501 42.6201C188.471 42.7501 187.631 44.1501 187.691 44.2701C187.811 44.5501 188.201 44.5301 188.501 44.4901C190.321 44.2501 192.201 45.6701 193.941 45.1001C195.321 44.6501 197.051 44.2901 197.711 44.4601",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.03 48.1494C196.24 50.8694 194.74 52.4094 193.68 53.7994C193.61 53.8894 193.7 54.0394 193.78 54.1294C193.84 54.1994 193.94 54.2394 194.03 54.2694C195.16 54.6794 196.32 55.0894 197.51 55.0094C197.9 54.9794 198.3 54.9094 198.68 54.9894C198.94 55.0494 199.18 55.1794 199.42 55.2894C200.87 56.0094 203.46 57.3794 205.08 57.3494",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.021 34.0501C207.411 33.7001 207.81 33.3701 208.23 33.0501C208.54 32.8201 208.891 32.5801 209.291 32.5901C209.531 32.6001 209.76 32.7001 210 32.7401C210.4 32.8101 210.8 32.7001 211.2 32.6601C212.4 32.5201 213.59 32.9101 214.74 33.2901",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39 49.8594C206.31 50.0594 205.23 50.2694 204.14 50.4694C203.2 50.6494 202.22 50.8394 201.44 51.3894C200.56 51.9994 200.01 52.9894 199.21 53.7094C198.53 54.3094 197.68 54.7094 196.78 54.8394",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.501 48.5596C214.331 48.6596 214.181 48.7796 214.021 48.8896C213.651 49.1696 213.281 49.4396 212.921 49.7196C212.551 49.9996 212.161 50.2996 211.971 50.7296C211.941 50.7896 211.921 50.8596 211.941 50.9196C211.951 50.9696 211.991 51.0196 212.031 51.0596C212.621 51.6696 213.201 52.2696 213.791 52.8796C213.831 52.9196 213.871 52.9596 213.921 52.9596C213.981 52.9696 214.041 52.9196 214.081 52.8796C214.531 52.5096 215.161 52.3696 215.731 52.5196",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.381 48.7399C214.321 48.6999 214.461 48.6599 214.511 48.7099C215.051 49.2099 215.601 49.7099 216.141 50.2099",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.11 49.5901C215.98 49.0801 215.78 48.5901 215.75 48.0701C215.72 47.5501 215.91 46.9601 216.38 46.7301C216.6 46.6701 216.85 46.8201 216.94 47.0301C217.04 47.2401 217.01 47.4901 216.94 47.7101C216.91 47.8001 216.88 47.8901 216.89 47.9801C216.93 48.2601 217.32 48.2801 217.6 48.2201C217.51 48.6001 217.87 48.9801 218.26 49.0201C218.39 49.0301 218.54 49.0201 218.66 49.0901C218.93 49.2401 218.85 49.6501 218.73 49.9301C218.66 50.1101 218.57 50.2901 218.4 50.3801C218.29 50.4401 218.17 50.4401 218.05 50.4501C217.69 50.4601 217.33 50.4501 216.97 50.4201",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.74 47.3896C218.72 46.4296 218.69 45.4696 218.67 44.5196C218.67 44.4396 218.66 44.3396 218.58 44.2996C218.53 44.2796 218.47 44.2896 218.42 44.2996C217.51 44.4996 216.57 44.5796 215.64 44.5496C215.53 44.5496 215.4 44.5496 215.31 44.6196C215.24 44.6796 215.22 44.7796 215.21 44.8596C215.09 45.5496 215.11 46.2596 215.27 46.9396",
    fill: "#C2255C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.901 53.99C223.481 53.56 224.071 53.13 224.651 52.71C224.831 52.58 225.03 52.41 225.01 52.18C224.99 52.01 224.85 51.89 224.73 51.77C224.26 51.33 223.671 49.64 223.141 49.76C222.761 49.85 221.41 51.57 221.19 51.89C221.31 52.09 222.871 54.01 222.901 53.99Z",
    fill: "#C2255C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.421 48.7701C219.921 49.0701 220.601 49.3501 221.061 48.9701C221.371 48.7101 221.421 48.2101 221.191 47.8801C220.961 47.5501 220.511 47.4001 220.121 47.5001C220.381 47.1701 220.331 46.6401 220.021 46.3601C219.711 46.0801 219.181 46.0901 218.881 46.3801C218.891 46.4301 218.971 46.4501 219.011 46.4101C219.051 46.3701 219.021 46.2901 218.971 46.2801C218.731 46.7001 218.651 47.2001 218.751 47.6701C218.571 47.7101 218.371 47.7501 218.231 47.8601C218.081 47.9801 218.001 48.2001 218.091 48.3601C218.691 48.4301 219.291 48.4301 219.891 48.3601",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4 47.9301C228.45 47.9401 228.51 47.9501 228.55 47.9901C228.63 48.0601 228.63 48.1801 228.63 48.2901C228.65 48.7601 229 49.2101 229.47 49.2601C230.34 49.3401 231.37 49.1701 231.19 48.0901C231.06 47.3201 230.54 47.0201 229.84 46.9801C229.27 46.9401 228.18 46.7301 227.67 46.8201C227.28 46.8901 226.89 47.1001 227.09 47.5601C227.29 48.0001 228.03 47.8701 228.4 47.9301Z",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.371 49.2896C233.091 48.9796 232.781 48.5996 232.841 48.1796C232.901 47.7796 233.291 47.4996 233.691 47.4296C234.091 47.3596 234.491 47.4596 234.881 47.5596C235.041 47.5996 235.211 47.6596 235.261 47.8196C235.281 47.8896 235.271 47.9596 235.251 48.0296C235.111 48.6096 234.641 49.0996 234.061 49.2596",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.611 53.6195C219.471 53.3395 219.081 53.2195 218.811 53.3695C219.421 53.0395 219.811 52.3295 219.211 51.7495C218.891 51.4395 218.581 51.5695 218.221 51.4595C218.111 51.4295 218.091 50.9695 217.881 51.0595C217.001 51.3995 217.901 53.8995 217.881 54.4595C218.351 54.5195 220.141 54.6395 219.611 53.6195Z",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.141 53.0596C214.551 53.7596 214.801 54.5496 214.881 55.3596C215.651 55.1696 216.411 54.9196 217.151 54.6196C217.241 54.5796 217.341 54.5296 217.361 54.4396C217.381 54.3596 217.331 54.2696 217.281 54.1996C216.821 53.4796 216.541 52.6396 216.501 51.7896C216.491 51.6596 216.441 51.4796 216.311 51.4996C216.281 51.5096 216.251 51.5196 216.231 51.5396C215.841 51.7896 215.461 52.0396 215.071 52.2896",
    fill: "#FCC2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53 45.0396C219.54 44.4396 220.71 44.0996 221.88 44.0596C221.8 44.6896 221.88 45.3296 222.1 45.9296",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.311 44.9697C222.611 44.5597 222.91 44.1397 223.21 43.7297C223.27 43.6497 223.331 43.5697 223.411 43.5097C223.671 43.3197 224.04 43.4197 224.34 43.5497C224.64 43.6797 224.971 43.8297 225.271 43.7197C225.221 44.5797 225.04 45.4197 224.75 46.2297",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.63 46.6799C225.95 46.7599 225.25 46.6799 224.6 46.4599C224.31 46.3599 223.99 46.2299 223.7 46.3499C223.42 46.4599 223.28 46.7499 223.15 47.0199C222.89 47.5999 222.62 48.1799 222.36 48.7699",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.131 51.0201C224.651 50.4801 225.181 49.9301 225.701 49.3901C225.801 49.2901 225.911 49.1801 226.051 49.1401C226.181 49.1101 226.311 49.1401 226.431 49.1801C227.071 49.3601 227.711 49.5601 228.341 49.7801C228.081 50.0401 227.821 50.3301 227.731 50.6901C227.581 51.3101 228.021 51.9701 227.851 52.5901",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.921 44.4601C227.851 44.5001 227.871 44.3201 227.951 44.3501C228.031 44.3801 228.031 44.4901 228.021 44.5701C227.951 45.2401 228.051 45.9201 228.311 46.5401",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.421 46.9295C209.271 47.1895 210.101 47.5195 210.901 47.8995C210.971 47.2195 211.181 46.5595 211.531 45.9795",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.55 46.7697C212.53 46.5397 212.63 46.2797 212.84 46.1797C213.05 46.0697 213.35 46.1797 213.4 46.4097C213.48 46.7597 213.01 47.1297 213.23 47.4097C213.31 47.5097 213.45 47.5397 213.57 47.5797C213.89 47.7097 214.11 48.0497 214.08 48.3997C214.05 48.7397 213.78 49.0497 213.45 49.1297C213.27 49.1697 213.07 49.1497 212.88 49.1697C212.64 49.1997 212.42 49.2897 212.19 49.3397C211.64 49.4597 211 49.3097 210.66 48.8597C210.51 48.9997 210.31 49.0997 210.1 49.1297C209.97 49.0697 209.89 48.9097 209.93 48.7597",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62 52.0602C208.73 51.7802 208.94 51.5402 209.22 51.4202C209.5 51.3102 209.85 51.3602 210.04 51.5902C210.24 51.8202 210.22 52.2102 209.97 52.3802C210.16 52.1302 210.54 52.0402 210.83 52.1802C211.12 52.3202 211.28 52.6702 211.2 52.9802C211.46 53.0702 211.77 53.2702 211.67 53.5202C211.63 53.6302 211.52 53.6902 211.42 53.7502C211.18 53.8802 210.94 54.0102 210.7 54.1502",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.08 49.6994C209.17 49.3394 209.65 49.1294 209.97 49.3294",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41 56.2695C210.3 55.5295 210.19 54.7895 210.08 54.0395C210.07 53.9695 210.06 53.8995 210.1 53.8495C210.15 53.7695 210.26 53.7695 210.35 53.7695C211.23 53.7795 212.1 53.7895 212.98 53.7995C213.05 53.7995 213.12 53.7995 213.17 53.8495C213.24 53.8995 213.25 53.9995 213.25 54.0795C213.3 54.9895 213.35 55.8995 213.4 56.8195",
    fill: "#F06595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.681 31.79C230.571 32.16 228.461 32.52 226.351 32.89C225.601 33.02 224.831 33.15 224.081 33.05C223.601 32.99 223.141 32.83 222.661 32.79C222.181 32.74 221.661 32.82 221.311 33.16C221.101 33.36 220.971 33.64 220.961 33.93",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.271 39.8602C227.171 40.0202 230.18 40.1602 231.07 39.9102C231.96 39.6702 232.781 39.0402 233.051 38.1602C233.201 37.6702 233.14 37.0802 232.76 36.7402",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.33 26.1797C225.55 26.1997 224.78 26.2097 224 26.2297C223.51 26.2397 223.011 26.2497 222.541 26.3597C221.251 26.6497 220.211 27.6097 219.391 28.6497C219.051 29.0797 218.73 29.5697 218.73 30.1197C218.74 30.7597 219.2 31.3397 219.12 31.9697C219.11 32.0797 219.06 32.1997 218.95 32.2297C218.84 32.2597 218.74 32.0797 218.84 32.0397",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35 60.6303C225.21 59.1103 224.5 57.6403 223.4 56.5803C223.02 56.2103 222.56 55.8403 222.5 55.3203",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.891 58.4196C233.711 57.3796 232.821 56.6496 232.211 55.7896C231.851 55.2896 231.581 54.7296 231.311 54.1796C230.951 53.4496 230.601 52.5796 230.961 51.8496",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.78 47.3096C246.41 48.8996 247.58 51.0496 247.91 53.2996C248.38 56.4396 246.37 62.8296 245.61 63.8096",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 67.79C183.22 68.98 182.98 70.51 183.35 71.88C183.72 73.25 184.69 74.45 185.96 75.1",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.591 59.96C217.191 60.3 217.531 60.97 217.661 61.65C217.781 62.33 217.711 63.02 217.661 63.7C217.521 65.49 217.521 67.28 217.641 69.07",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.291 42.7794C181.091 42.0094 183.181 40.9494 184.811 39.8594",
    stroke: "#E64980",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.25 44.8202C234.03 44.0202 234.84 43.2402 235.67 42.4902",
    stroke: "#F06595",
    strokeWidth: 1.2016,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.011 42.0001C206.491 42.3301 205.861 42.4801 205.251 42.4101C204.791 42.3601 204.301 42.1401 204.141 41.7001C203.981 41.2601 204.411 40.6801 204.841 40.8401C204.721 40.7901 204.591 40.7401 204.471 40.6901C204.071 40.5201 203.631 40.3201 203.461 39.9201C203.291 39.5201 203.661 38.9301 204.061 39.0901C203.751 38.8701 203.431 38.6401 203.251 38.3001C203.071 37.9601 203.091 37.4901 203.391 37.2601C203.681 37.0401 204.101 37.1201 204.431 37.2801C204.761 37.4501 205.051 37.6901 205.401 37.7801C204.981 37.3301 204.671 36.7801 204.491 36.2001C204.421 35.9701 204.371 35.7101 204.501 35.5001C204.661 35.2401 205.041 35.1901 205.321 35.3101C205.601 35.4301 205.811 35.6801 206.001 35.9101C205.611 35.2101 205.381 34.4101 205.361 33.6101C205.351 33.3501 205.391 33.0401 205.621 32.9001C205.951 32.7001 206.351 33.0601 206.501 33.4201C206.651 33.7801 206.761 34.2101 207.121 34.3701C207.231 34.4201 207.351 34.4301 207.441 34.5201C207.531 34.6101 207.551 34.7401 207.571 34.8701C207.641 35.4101 207.711 35.9601 207.781 36.5001C208.061 36.2401 208.531 36.2201 208.841 36.4401C209.151 36.6701 209.261 37.1301 209.091 37.4701C209.221 37.2801 209.421 37.1501 209.651 37.1101C209.741 37.2301 209.791 37.3601 209.821 37.5001C210.101 37.0801 210.521 36.7401 210.991 36.5701C211.171 36.5001 211.391 36.4601 211.551 36.5701C211.701 36.6701 211.741 36.8601 211.781 37.0401C211.851 37.3701 211.911 37.7001 211.981 38.0401C212.001 38.1301 212.041 38.2501 212.131 38.2501C212.221 38.2501 212.201 38.0501 212.131 38.1201",
    fill: "#C2255C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.57 38.1094C212.35 37.0594 213.36 36.1794 214.51 35.5494C214.6 35.4994 214.73 35.4494 214.8 35.5294C214.85 35.5794 214.85 35.6594 214.84 35.7294C214.81 35.9894 214.73 36.2494 214.62 36.4894C214.67 35.3794 215.58 34.3694 216.67 34.1994C216.74 34.1894 216.82 34.1794 216.89 34.2194C217.17 34.3594 216.81 34.7794 216.88 35.0894C216.92 35.2394 217.06 35.3394 217.09 35.4994C217.12 35.6294 217.05 35.7594 216.98 35.8794C216.6 36.5494 216.11 37.1494 215.55 37.6694C215.69 37.5994 215.86 37.7194 215.9 37.8694C215.94 38.0194 215.88 38.1794 215.81 38.3194C215.4 39.2294 214.68 39.9894 213.8 40.4594",
    fill: "#C2255C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.141 43.54C216.141 43.54 214.681 37.93 210.801 38.43C206.921 38.93 206.921 44.46 206.921 44.46C206.921 44.46 211.531 47.23 216.141 43.54Z",
    fill: "#D6336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.73 22.7694C273.99 22.0394 274.77 21.8894 274.77 20.4294V19.6494L233.91 44.4594L272.73 22.7694Z",
    fill: "#E64980"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.94 129.18L203.28 97.9404",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.25 126.78L163.63 99.1396",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3496 8.00977L25.9496 15.6098",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9504 85.4502L11.9805 92.5902",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 118.5L30.5 91.5",
    stroke: "#F783AC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingRightImage);
export default __webpack_public_path__ + "static/media/cookingRightImage.f5a332fe6bb0a149ef9e6877b6ca6005.svg";
export { ForwardRef as ReactComponent };